import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const RECOMMENDATION_DATA = {
  tax: {
    to: "/tax-filing",
    imgSrc: "complex_tax_card.svg",
    altText: "Complex Tax Filing",
    staticTitle: "Complex Tax?",
    // We add the dynamic rotation list here
    dynamicList: [
      "Get a Certified Tax Pro",
      "Plaintr connects you with the right one",
      "START TODAY",
    ],
  },
};

/**
 * ServiceRecommendation
 *
 * This should render Plaintr's services like Tax Filing, Financial Insights, etc.
 * Meant to be used as children of ProductRecommendation component
 *
 */
function ServiceRecommendation({ type = "tax" }) {
  const data = RECOMMENDATION_DATA[type] || RECOMMENDATION_DATA.tax;
  const [index, setIndex] = useState(0);
  useEffect(() => {
    // Only set interval if there is more than one item to rotate
    if (data.dynamicList.length <= 1) return;

    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % data.dynamicList.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [data.dynamicList.length]);

  return (
    <div className="service-reomendation">
      <Link to={data.to} className="image-link-wrapper">
        <img
          src={`${process.env.PUBLIC_URL}/images/${data.imgSrc}`}
          alt={data.altText}
        />
        <div className="image-text-overlay">
          <span className="static-text">{data.staticTitle}</span>
          {/* We use the key property to re-trigger the CSS animation on change */}
          <span className="dynamic-text animate-fade" key={index}>
            {data.dynamicList[index]}
          </span>
        </div>
      </Link>
    </div>
  );
}

export default ServiceRecommendation;
